// extracted by mini-css-extract-plugin
module.exports = {"header":"ForumTopics_header","title":"ForumTopics_title","btn":"ForumTopics_btn"};